import React from "react";
import { Mail, ArrowRight } from "lucide-react";
import PageShell, { Section } from "@/components/PageShell";

const Press = () => (
  <PageShell
    eyebrow="// Press & media"
    title="Press & Media"
    subtitle="GigAfloat welcomes inquiries from journalists, podcast hosts, media organizations, bloggers, and content creators."
    testid="press-page"
  >
    <Section>
      <p>
        For interviews, press requests, partnership opportunities, or media information, please contact us directly. We aim to respond within two business days.
      </p>
    </Section>

    <Section title="Media contact">
      <div className="rounded-2xl border border-white/8 bg-white/[0.02] p-5">
        <div className="font-display font-extrabold text-lg">GigAfloat Media Relations</div>
        <a
          href="mailto:gigafloatapp@gmail.com?subject=Press%20Inquiry"
          className="mt-1 inline-flex items-center gap-2 text-[#00FF88] hover:text-white transition-colors font-mono-c text-sm"
          data-testid="press-email"
        >
          <Mail className="w-4 h-4" />
          gigafloatapp@gmail.com
        </a>
      </div>
    </Section>

    <Section title="About">
      <p>
        GigAfloat is an early-stage company building financial flexibility tools for gig workers. We&apos;re based in Atlanta and currently in private beta, gathering feedback from independent workers across the country.
      </p>
    </Section>

    <a
      href="mailto:gigafloatapp@gmail.com?subject=Press%20Inquiry"
      className="mt-4 inline-flex items-center gap-2 bg-[#00FF88] text-black font-bold text-sm px-6 py-3 rounded-full btn-glow"
      data-testid="press-cta"
    >
      Contact press team <ArrowRight className="w-4 h-4" />
    </a>
  </PageShell>
);

export default Press;
